// Pure branch-selection for the Greyfinch panel body, lifted out of the JSX so all states are unit-tested
// (the load-bearing invariant is that loading is decided BEFORE the linked check — reordering them would
// flash "isn't linked" at a real linked patient).
export const GreyfinchPanelState = {
  Loading: 'loading',
  NotConnected: 'notConnected',
  Unavailable: 'unavailable',
  NotLinked: 'notLinked',
  Populated: 'populated'
}

// Greyfinch's not-connected state (424 GREYFINCH_NOT_CONNECTED) is distinct from a vendor outage: the
// feature flag and the practice's Client Key are independent switches, so 424 is the EXPECTED state the
// first time the flag is flipped for a practice that hasn't connected the app — it must steer the doctor
// to connect, not tell them to wait for a "temporarily unavailable" vendor. `error.response.status` is the
// app's house idiom for reading a status off a rejected request (utils/bulkInviteUtils.js).
const NOT_CONNECTED_STATUS = 424

export const resolveGreyfinchPanelState = ({ grinPatientId, isUninitialized, isFetching, isError, error, data }) => {
  // Un-asked (no patient id / skip) and the first render before RTK Query dispatches both read as loading,
  // never as a negative claim about a real PMS record.
  if (!grinPatientId || isUninitialized || isFetching) {
    return GreyfinchPanelState.Loading
  }
  if (isError) {
    const status = error?.response?.status ?? error?.status
    return status === NOT_CONNECTED_STATUS ? GreyfinchPanelState.NotConnected : GreyfinchPanelState.Unavailable
  }
  // Fail safe: only assert "linked" on an explicit truthy flag — undefined/null reads as not linked.
  if (!data || !data.linked) {
    return GreyfinchPanelState.NotLinked
  }
  return GreyfinchPanelState.Populated
}
